// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__hxFmF","terms":"styles_terms__Q67ob","spin":"styles_spin__7K3u3"};